export default "__VITE_ASSET__BLahxcrR__"